export default {
  items: [
    {
      name: "Re-Installation",
      url: "/keyholder/re-install",
      icon: "fa fa-gears fa-lg",
      attributes: { "data-cy": "reinstallation" },
    },
  ],
};
